// Genome shape. A genome is a fixed-length vector of alleles, where each
// allele is a small integer in [0, ALLELE_MAX]. One gene per registered
// base trait, plus a few "hidden" genes consumed only by emergent-trait
// recipes (room to encode latent variation without inflating the trait UI).

import type { Rng } from './rng';
import { randInt } from './rng';

export type Allele = number;
export type Genome = readonly Allele[];

export const ALLELE_MAX = 15;
export const ALLELE_VALUES = ALLELE_MAX + 1; // 16 distinct values per gene

/** Hidden genes appended after the registered base traits. */
export const HIDDEN_GENE_COUNT = 4;

/** Build a random genome of length `length`. */
export function randomGenome(rng: Rng, length: number): Genome {
  const g: Allele[] = new Array(length);
  for (let i = 0; i < length; i++) {
    g[i] = randInt(rng, 0, ALLELE_MAX);
  }
  return g;
}

/** Clamp an allele back into the legal range. */
export function clampAllele(v: number): Allele {
  if (v < 0) return 0;
  if (v > ALLELE_MAX) return ALLELE_MAX;
  return v | 0;
}

/** Stable string fingerprint for caches (sprite composer, emergent trait cache). */
export function genomeKey(g: Genome): string {
  // Each allele 0..15 fits in one hex digit.
  let s = '';
  for (let i = 0; i < g.length; i++) {
    s += g[i]!.toString(16);
  }
  return s;
}
